import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IContestsStore} from "data/stores/contests/contestsStore";
import type {IRosterStore} from "data/stores/roster/roster.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import {IRosterPlayer} from "data/types/roster";

export interface IRosterListLayoutViewController extends ViewController {
	get contestId(): number;
	get rosterPlayers(): IRosterPlayer[];
}

@injectable()
export class RosterListLayoutViewController implements IRosterListLayoutViewController {
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.RosterStore) private readonly _rosterStore: IRosterStore,
		@inject(Bindings.ContestsStore) private readonly _contestStore: IContestsStore
	) {
		makeAutoObservable(this);
	}

	get contestId(): number {
		return this._contestStore.currentContest?.id || 0;
	}

	get rosterPlayers(): IRosterPlayer[] {
		return this._rosterStore.rosterPlayers;
	}
}
